import { Button } from "@shopify/polaris";
import React, { Fragment, useCallback, useReducer } from "react";

import { reducerFn } from "../../../helper";
import ProductTemplateUserAccessGrant from "./product-template-user-access-grant";
import ProductTemplateUserAccessRevoke from "./product-template-user-access-revoke";

export default function ProductTemplateBulkAction() {
  // State
  const [state, setState] = useReducer(reducerFn, {
    open: false,
    action: null,
  });

  const handleOpenAction = useCallback(
    (act) => () => {
      setState({ open: true, action: act });
    },
    [],
  );

  const handleCloseAction = useCallback(() => {
    setState({ open: false, action: null });
  }, []);

  const actionObj = {
    grantAccess: (
      <ProductTemplateUserAccessGrant
        open={state.open}
        onClose={handleCloseAction}
      />
    ),
    revokeAccess: (
      <ProductTemplateUserAccessRevoke
        open={state.open}
        onClose={handleCloseAction}
      />
    ),
  };

  const actionMarkup = actionObj[state.action];

  return (
    <Fragment>
      <Button
        children="Grant access"
        onClick={handleOpenAction("grantAccess")}
      />
      <Button
        children="Revoke access"
        onClick={handleOpenAction("revokeAccess")}
      />
      {actionMarkup}
    </Fragment>
  );
}
